import AbstractValidator from './AbstractValidator';
import Time from './Time';

export default class DateValidator extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        notDate: 'Das eingebenene Datum ist kein gültiges Datum.',
    };

    run()
    {
        if('H:i' === this._options?.format)
        {
            const TimeValidator = new Time(this.value, {});
            TimeValidator.run();

            if(TimeValidator.error)
            {
                this.error = TimeValidator.error;

                return;
            }
        }
        else
        {
            if (!this.value?.match(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/) || new Date(this.value).toString() === 'Invalid Date')
            {
                this.error = this.getMessage('notDate');
            }
        }
    }
}